import React from 'react';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';
import ActionsBlock from './components/datatable/ActionsBlock';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;
//Columns
/*
   registration_received_id
      , msid_country 
      , message_id
      , message_timestamp 
      , application_type 
      , vat_number
      , company_name
      , change_date
      , address_free
      , address_country
      , telephone
      , email
      , websites
      , trading_names
      , country_of_business
      , bank_iban
      , bank_account
      , bank_bic
      , request_date
      , commencement_date 
      , registration_date 
      , incoming_message_id 
      , vat_number_int 
      , not_established 
      , electronic_interface 
      , other_msnetp 
      , previous_registrations 
      , contact_name_free 
      , vat_group 
     */
//table key
//registration_received_id
export const TableColumns = [
  {
    label: '#',
    id: 'registration_received_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'message_id',
  //   id: 'message_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Vat Number',
    id: 'vat_number',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'MSID Country',
    id: 'msid_country',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Company Name',
    id: 'company_name',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },

  // {
  //   label: 'address_free',
  //   id: 'address_free',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'address_country',
  //   id: 'address_country',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'telephone',
  //   id: 'telephone',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'email',
  //   id: 'email',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'websites',
  //   id: 'websites',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'contact_title',
  //   id: 'contact_title',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'contact_first_name',
  //   id: 'contact_first_name',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'contact_last_name',
  //   id: 'contact_last_name',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'trading_names',
  //   id: 'trading_names',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'Country of Business',
  //   id: 'country_of_business',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'vat_group',
  //   id: 'vat_group',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'bank_iban',
  //   id: 'bank_iban',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'bank_account',
  //   id: 'bank_account',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'bank_bic',
  //   id: 'bank_bic',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'request_date',
  //   id: 'request_date',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'commencement_date',
  //   id: 'commencement_date',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  {
    label: 'Registration Date',
    id: 'registration_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },

  {
    label: 'Change Date',
    id: 'change_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {DatesUtils.formatDateTimeSeconds(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },

  {
    label: 'Exclusion',
    id: 'exclusion_code',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        <span
          style={{
            color:
              cellValue === null ? 'black' : cellValue > 0 ? 'red' : 'orange',
          }}
        >
          {cellValue === null ? 'N/A' : cellValue > 0 ? 'Yes' : 'Cancelled'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },

  // {
  //   label: 'created_by',
  //   id: 'created_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'created_at',
  //   id: 'created_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'modified_by',
  //   id: 'modified_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'modified_at',
  //   id: 'modified_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'incoming_message_id',
  //   id: 'incoming_message_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        registration_id={data[rowIndex].registration_received_id}
        error={data[rowIndex].error}
        incoming_message_id={data[rowIndex].incoming_message_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Registrations Received',
    [Languages.English]: 'Registrations Received',
  },
  title: {
    [Languages.Greek]: 'Registrations Received',
    [Languages.English]: 'Registrations Received',
  },
  description: {
    [Languages.Greek]:
      'Below is a list of the Payment Reminders received by other Member States (MSIDs) for VAT Returns that were not fully settled, at the time of the reminder, by the Applicant registered in our System. These reminders should be taken into account when allocating the payment amounts for the corresponding VAT Return.',
    [Languages.English]:
      'Below is a list of the Payment Reminders received by other Member States (MSIDs) for VAT Returns that were not fully settled, at the time of the reminder, by the Applicant registered in our System. These reminders should be taken into account when allocating the payment amounts for the corresponding VAT Return.',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  vat_number: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  msidCountry: {
    [Languages.Greek]: 'MSID Country',
    [Languages.English]: 'MSID Country',
  },
  schemeType: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
};
